export const roles = ["Producer", "Executive Producer", "Producer Lead"]
export const projectTypes = ["project type 1", "project type 2", "project type 3"]